import React from 'react';
import FeeWaiver from './FeeWaiver';
import '../../../CommonCSS/SocietyCSS.css'

const FeeWaiverApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Fees Waiver</h5>
          </div>  
        </div>
        <FeeWaiver/>
      </div>
    </div >
  );
};

export default FeeWaiverApp;
